import axios from "axios";
import DataTable from "./subcomponents/DataTable";
import { useEffect, useState } from "react";
import config from "../config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import Pagination from "./Pagination";

const Visitors = () => {
    const tabName = ['Unique Visitors', 'Returning Visitors', 'Total Trades', 'Total Posts'];
    const [currentTab, setcurrentTab] = useState('Unique Visitors');
  const analyticstoken = localStorage.getItem("analyticstoken");
  const [trade_count, settrade_count] = useState(null);
  const [post_count, setpost_count] = useState(null)
  const [selectedDate, setSelectedDate] = useState(null);
  const [data, setdata] = useState([]);
  const [filter_date, setfilter_date] = useState("");
  useEffect(() => {
    if(filter_date){
        getData();
    }
    //eslint-disable-next-line
  }, [filter_date]);

  const getData = async (url) => {
    setdata([]);
    try {
      const response = await axios.post(
        `${config.backendUrl}${url}`,
        {
          date: filter_date,
        }
      );
      console.log(response.data);
      if (response.data.status === 1) {
        if(currentTab == 'Total Trades'){
            settrade_count(response.data.data.trade_count);
        }else if(currentTab == 'Total Posts'){
            setpost_count(response.data.data.post_count);
        } else {
            setdata(response.data.data.visitors);
        }
      } else {
        setdata([]);
      }
    } catch (error) {
      setdata([]);
    }
  };
  const changeDate = (date) => {
    setSelectedDate(date);
    const demodate = dayjs(date).format("YYYY-MM-DD");
    setfilter_date(demodate);
  };
  useEffect(() => {
    if (filter_date) {
        if(currentTab == 'Unique Visitors'){
            getData('/api/analytics/unique-visitors');
        }
        if(currentTab == 'Returning Visitors'){
            getData('/api/analytics/returning-visitors');
        }
        if(currentTab == 'Total Trades'){
            getData('/api/analytics/trade-count');
        }
        if(currentTab == 'Total Posts'){
            getData('/api/analytics/post-count');
        }
    
    }
  }, [filter_date]);
  function fancyTimeFormat(duration) {
    // Hours, minutes and seconds
    const hrs = ~~(duration / 3600);
    const mins = ~~((duration % 3600) / 60);
    const secs = ~~duration % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    let ret = "";

    if (hrs > 0) {
      ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }

    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;

    return ret;
  }
 
  
  return (
    <div className="container analytics-list">
      <div className="row">
        <div className="col-12">
          <h1 className="heading-analytics">Visitors Records</h1>
        </div>
        <ul className="nav ">
            {tabName.map((item, key) => (
                <li className={currentTab == item ? "nav-item vactive" : "nav-item"} key={key} style={{cursor: 'pointer',fontSize: '1.3rem'}} onClick={() => {
                    setcurrentTab(item);
                    setfilter_date('');
                    setdata([]);
                    setSelectedDate(null);
                    settrade_count(null);
                    setpost_count(null);
                    }}>
                <a className="nav-link" >{item}</a>
            </li>))}
            
        </ul>

        
            {(currentTab == 'Unique Visitors' || currentTab == 'Returning Visitors') && 
            <div>
            <div className="col-12 pt-4">
            <label className="filterdate">
                Filter with date<br></br>
                <DatePicker
                selected={selectedDate}
                value={selectedDate}
                onChange={(date) => changeDate(date)}
                dateFormat="MM/dd/yyyy"
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"
                placeholderText="Filter with date"
                />
            </label>
            </div>
            <div className="col-12 pt-4">
            <div className="analytics-table-card fulltable">
                <table className="analytics-table ">
                <thead>
                    <tr>
                    <th>Name</th>
                    <th>Duration</th>
                    <th>IP Address</th>
                    <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length == 0 && (
                    <tr >
                        <td colSpan={5} className="text-center" >No records found.</td>
                    </tr>
                    )}
                    {data.map((item, key) => (
                    <tr key={key}>
                        <td>{item.user}</td>
                        <td>{fancyTimeFormat(item.totalDuration)}</td>
                        <td>
                        {" "}
                        {item.ip_address && item.ip_address}{" "}
                        {!item.ip_address && "N/A"}
                        </td>
                        <td>
                        {" "}
                        {dayjs(item.firstVisitOnDate).format("MM-DD-YYYY HH:mm:ss")}
                        </td>
                    </tr>
                    ))}
                </tbody>
                </table>
            </div>
            </div>
            </div>
}
{currentTab == 'Total Trades' && 
            <div>
            <div className="col-12 pt-4">
            <label className="filterdate">
                Filter with date<br></br>
                <DatePicker
                selected={selectedDate}
                value={selectedDate}
                onChange={(date) => changeDate(date)}
                dateFormat="MM/dd/yyyy"
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"
                placeholderText="Filter with date"
                />
            </label>
            </div>
           {trade_count && <div className="col-12 pt-4">
            <div className="card-records">
            <h2>{trade_count}</h2>
            <p>Trade Count</p>
          </div>
            </div>}
            </div>
}

{currentTab == 'Total Posts' && 
            <div>
            <div className="col-12 pt-4">
            <label className="filterdate">
                Filter with date<br></br>
                <DatePicker
                selected={selectedDate}
                value={selectedDate}
                onChange={(date) => changeDate(date)}
                dateFormat="MM/dd/yyyy"
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"
                placeholderText="Filter with date"
                />
            </label>
            </div>
            {post_count && <div className="col-12 pt-4">
            <div className="card-records">
            <h2>{post_count}</h2>
            <p>Post Count</p>
          </div>
            </div>}
            </div>
}
        
      </div>
    </div>
  );
};

export default Visitors;
